import { Card } from 'react-bootstrap';
import logoDashboard from '../../assets/logo_dashboard.png';

export default function WelcomeCard() {

  return (

    <Card className="bg-white rounded-4 shadow-lg border-0">
      <Card.Body className="p-5">
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center"}}>
          <img src={logoDashboard} alt={"Imagem"} style={{
            maxWidth: "300px",
            maxHeight: "300px",
            objectFit: "contain",
          }} />
        </div>
      </Card.Body>
    </Card>
  );
}